// let imageBaseURL = 'http://192.168.1.109:3000/';
let imageBaseURL = 'https://bridgetalk.org/';
// let imageBaseURL = 'https://btalkserver.com/';

export default imageBaseURL;
